import React from 'react'
import { Helmet } from 'react-helmet'

import { graphql } from 'gatsby'
import { CardColumns, Jumbotron } from 'reactstrap'

import { flattenFileNode } from '../helpers'

import Layout from '../components/layout'
import ArticlePreview from '../components/article-preview'

export default indexPage

function indexPage({ data, location }) {
  // aplat des objets
  let nodes = data.allMarkdownRemark.edges.map(flattenFileNode)

  // On les classe par date décroissante
  nodes.sort((a, b) => {
    const dA = new Date(a.modifiedDate)
    const dB = new Date(b.modifiedDate)
    return dB - dA
  })
  nodes = nodes.slice(0, 6)

  return (
    <Layout location={location} data={data}>
      <Helmet>
        <meta name="robots" content="index, follow" />
        <meta name="msvalidate.01" content="23C4486B3F6CCCF85A73AA582BA8DF9E" />
        <title>
          lyceum un site open-source de cours et d&apos;exercices pour le lycée
        </title>
        <meta
          name="keywords"
          content="cours, lycée, informatique, snt, nsi, lyceum"
        />
        <meta
          name="description"
          content="Un site open-source pour les lycéens."
        />
        <meta
          name="classification"
          content="lycée cours physique chimie informatique"
        />
        <meta name="author" content="Benjamin Abel" />
      </Helmet>
      <Jumbotron>
        <h1 className="display-3">Derniers cours</h1>
      </Jumbotron>
      <CardColumns>
        {nodes.map((node) => (
          <ArticlePreview
            key={node.id}
            node={node}
            dataShowClasse
            dataShowMatter
            dataShowPart
            dataShowModifiedTime
          />
        ))}
      </CardColumns>
    </Layout>
  )
}

export const query = graphql`
  query HomeQuery {
    __typename
    allMarkdownRemark(filter: { fields: { type: { eq: "course" } } }) {
      edges {
        node {
          id
          parent {
            id
            ... on File {
              id
              name
            }
          }
          frontmatter {
            tags
          }
          fields {
            modifiedDate
            slug
            classe
            matter
            nPart
            part
            nChapter
            chapter
          }
        }
      }
    }
  }
`
